import cookie from "js-cookie";

export class CookieStorage {
  constructor() {}

  set(key, value) {
    const options = { expires: 30 };
    cookie.set(key, value, options);
  }

  get(key) {
    return cookie.get(key);
  }

  remove(key) {
    cookie.remove(key);
  }
}
